"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchPageHeader = void 0;
var react_1 = __importDefault(require("react"));
var AdvertiserDisclosure_1 = require("@nerdwallet/currency/components/AdvertiserDisclosure");
var CenteredContainer_1 = require("@nerdwallet/currency/components/CenteredContainer");
var Type_1 = require("@nerdwallet/currency/components/Type");
var seo_analytics_1 = require("@nerdwallet/seo-analytics");
var search_input_1 = __importDefault(require("../search-input/search-input"));
var useSegmentImpression_1 = require("../../lib/useSegmentImpression");
var search_page_header_module_css_1 = __importDefault(require("./search-page-header.module.css"));
var SearchPageHeader = function (_a) {
    var currentPage = _a.currentPage, pageSize = _a.pageSize, searchInputProps = _a.searchInputProps, totalResults = _a.totalResults, _b = _a.loading, loading = _b === void 0 ? false : _b;
    var start = (currentPage - 1) * pageSize + 1;
    var end = start + pageSize - 1;
    var analyticsPageView = (0, seo_analytics_1.useAnalyticsPageView)();
    var segmentRef = (0, useSegmentImpression_1.useSegmentImpression)({
        eventName: "feature_viewed",
        segmentAttributes: {
            entity_name: "onsite_search_result_page_info",
            section_name: "onsite_search",
            item_position: currentPage,
            parent_event_id: analyticsPageView === null || analyticsPageView === void 0 ? void 0 : analyticsPageView.pageViewId,
            additional_attributes: [
                {
                    "total results page count for the search": totalResults,
                    "result links count in the page": pageSize,
                },
            ],
        },
    }).ref;
    return (react_1.default.createElement("div", { className: search_page_header_module_css_1.default.headerContainer },
        react_1.default.createElement(CenteredContainer_1.CenteredContainer, null,
            react_1.default.createElement(AdvertiserDisclosure_1.AdvertiserDisclosure, { enableAnalytics: false }),
            react_1.default.createElement(search_input_1.default, __assign({ className: search_page_header_module_css_1.default.searchInput }, searchInputProps)),
            loading ? (react_1.default.createElement(Type_1.Type, { size: 2 }, "Loading results...")) : totalResults === 0 ? (react_1.default.createElement(Type_1.Type, { size: 2 }, "No results found.")) : (react_1.default.createElement(Type_1.Type, { size: 2, ref: segmentRef },
                "Showing results ",
                start,
                " to ",
                end,
                " of ",
                totalResults)))));
};
exports.SearchPageHeader = SearchPageHeader;
exports.default = exports.SearchPageHeader;
